let { cut } = require('../../../../../helpers/utils');
let css = require('./controls.css');

let SELECTOR_UNSELECT = cut(css.unselect);
let SELECTOR_SELECT = cut(css.select);
let SELECTOR_SHOW_SELECTED_ONLY = cut(css.showSelectedOnly);

class Controls {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    bind () {
        return {
            click: {
                [SELECTOR_UNSELECT]: this.onUnselect,
                [SELECTOR_SELECT]: this.onSelect,
                [SELECTOR_SHOW_SELECTED_ONLY]: this.onShowSelectedOnly
            }
        };
    }

    onUnselect (e) {
        e.stopPropagation();

        let signal = this.$context.props.onSetAll;
        this.$context.signal(signal, { value: false });
    }

    onSelect (e) {
        e.stopPropagation();

        let signal = this.$context.props.onSetAll;
        this.$context.signal(signal, { value: true });
    }

    onShowSelectedOnly (e) {
        e.stopPropagation();

        let basePath = this.$context.props.basePath;
        let treeId = this.$context.props.treeId;
        let signal = this.$context.props.onShowSelectedOnly;
        this.$context.signal(signal, { basePath, treeId });
    }
}

module.exports = function (customFilter) {
    let children = undefined;

    if (customFilter) {
        customFilter.name = 'custom-filter';
        children = [customFilter];
    }

    return {
        constructor: Controls,
        children: children
    };
};



// WEBPACK FOOTER //
// ./components/common/custom-order/filterable-tree/controls/index.js